import {Component, Input, OnInit} from '@angular/core';
@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html'
})
export class StepperComponent implements OnInit {
  @Input() journey: string;
  @Input() stepName: string;
  @Input() stepNumber: number;
  pageHeading: string;
  steps;

  ngOnInit() {
    if (this.journey === 'quote') {
      this.pageHeading = 'Get a car insurance quote in 60 seconds';
      this.steps = Array.from(Array(3));
    } else if (this.journey === 'activation') {
      this.pageHeading = 'Finalise your cover';
      this.steps = Array.from(Array(5));
    }
  }

}

